module.exports = __webpack_public_path__ + "ENG_SPS1-Basketball-666d55106b86e459cf287c4171ff9b7f.png";